import React from 'react';
import DashboardBarChartSkeleton from 'pages/Dashboard/shared/DashboardBarChart/DashboardBarChartSkeleton';

const VerticalBarChartSkeleton = () => (
  <DashboardBarChartSkeleton />
);

export default VerticalBarChartSkeleton;
